"use strict";
const productStickySectionOptions = {
    rootMargin: "0px",
    threshold: [0.1, 0.2, .3, .4, .5, 1],
};
const productStickyElmCallback = (entries, observer) => {
    entries.forEach((entry) => {
        // console.log(entry.intersectionRatio)
        const target = entry.target;
        if (entry.intersectionRatio < 0.1 && window.innerWidth < 550) {
            const elm = target.querySelector('.product-form__buttons');
            elm ? elm.classList.add("productStickyElm") : "";
        }
        if (entry.intersectionRatio >= 0.1) {
            const elm = target.querySelector('.product-form__buttons');
            elm ? elm.classList.remove("productStickyElm") : "";
        }
    });
};
const productStickyElmObserver = new IntersectionObserver(productStickyElmCallback, productStickySectionOptions);
const productStickyElmTarget = document.querySelector("#main_product_section");
productStickyElmTarget ? productStickyElmObserver.observe(productStickyElmTarget) : "";
